
 
  <div class="card " style="margin-bottom:0px !important;">
    <div class="card-body" style="padding-top:unset !important;">
      <div class="pb-2">
        <h5 class="card-title text-center pb-0 fs-4"><div><i class="bi bi-check-circle"></i></div>Честито</h5>
        <p class="text-center small">Успяхте успешно да извършите операцията</p>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-light w-100" (click)="closeModal()">Затвори</button>
        </div>
      </div> 
    </div>
  </div>
